import PropTypes from 'prop-types'

import {List, Map} from 'immutable'
import {Component} from 'react'

import ClientApprovalNote from './ClientApprovalNote'
import CustomMessageEditor from '../../customize_invite/CustomMessageEditor'
import LegacyEmailPreviews from '../../customize_invite/LegacyEmailPreviews'
import RequestItemPermissionsContainer from './RequestItemPermissionsContainer'
import Forms from '../../../../../shared_components/forms'
import HighComplianceNote from '../../customize_invite/HighComplianceNote'
import LegacyToAndFrom from '../../customize_invite/LegacyToAndFrom'
import ButtonGroup from '../../../../../shared_components/core/buttons/ButtonGroup'

import {Cancel, Accept} from '../../../../../dashboard/src/components/blocks/Buttons'
import {isFuneralHome} from '../../../lib/firmTools'
import {requestedItemPermissions} from '../../../../../lib/itemPermissionTools'

import './inviteClient.scss'

export default class InviteClient extends Component {
  constructor() {
    super()

    this.state = {
      processing: false,
      itemPermissionIds: []
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.saveItemPermissions = this.saveItemPermissions.bind(this)
  }

  saveItemPermissions(checkedItemIds) {
    this.setState({itemPermissionIds: checkedItemIds})
  }

  handleSubmit() {
    this.setState({processing: true})
    const formData = this.refs.form.formData()

    this.props.handleSubmit({
      inviteText: formData.invite_text,
      saveEdits: formData.save_edits,
      itemPermissions: requestedItemPermissions({itemIds: this.state.itemPermissionIds, permissionType: 'edit'})
    })
  }

  anyoneActive() {
    return this.props.clientSeats.some(clientSeat => clientSeat.get('status') === 'Active')
  }

  // Sales Studio shell firms hold client invites until an account manager marks
  // setup complete - the backend rejects the send, so disable the button too.
  firmPendingSetup() {
    return Boolean(this.props.firm && this.props.firm.get('pending-setup'))
  }

  render() {
    return (
      <div className='invite-client'>
        <HighComplianceNote isHighCompliance={this.props.isHighCompliance} />
        <LegacyToAndFrom {...this.props} recipients={[this.props.recipient]} />
        <Forms.Form ref='form'>
          <CustomMessageEditor {...this.props} />
        </Forms.Form>
        {
          !isFuneralHome(this.props.firm) &&
          <RequestItemPermissionsContainer
            needsClientApproval={this.props.needsClientApproval}
            clientSeat={this.props.clientSeat}
            anyoneActive={this.anyoneActive()}
            saveItemPermissions={this.saveItemPermissions}
          />
        }
        <LegacyEmailPreviews {...this.props} />
        <ClientApprovalNote {...this.props} />
        {
          this.firmPendingSetup() &&
          <p className='pending-setup-note' role='note'>
            An invitation cannot be sent while this firm's setup is incomplete.
            It will be sent automatically once setup is marked complete.
          </p>
        }
        <ButtonGroup>
          <Cancel onClick={this.props.closeModal} />
          <Accept
            disabled={this.firmPendingSetup()}
            onClick={this.handleSubmit}
            processing={this.state.processing}>
            Send Invitation
          </Accept>
        </ButtonGroup>
      </div>
    )
  }
}

InviteClient.defaultProps = {
  disclosure: {
    data: {}
  }
}

InviteClient.propTypes = {
  anyoneActive: PropTypes.bool,
  closeModal: PropTypes.func,
  disclosure: PropTypes.shape({
    enabled: PropTypes.bool,
    markdown_text: PropTypes.string,
    show_in_email: PropTypes.bool
  }),
  firm: PropTypes.instanceOf(Map),
  isHighCompliance: PropTypes.bool,
  recipient: PropTypes.object,
  contactCard: PropTypes.shape({
    name: PropTypes.string
  }),
  emailTexts: PropTypes.array,
  handleSubmit: PropTypes.func,
  household: PropTypes.shape({
    clients: PropTypes.array
  }),
  clientSeat: PropTypes.instanceOf(Map),
  clientSeats: PropTypes.instanceOf(List),
  userConfig: PropTypes.instanceOf(Map),
  needsClientApproval: PropTypes.bool
}
